import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ICONS } from './icon-loader.const';

@Injectable({
  providedIn: 'root',
})
export class IconLoaderService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    for (const icon of ICONS) {
      this.matIconRegistry.addSvgIconLiteral(icon.label, domSanitizer.bypassSecurityTrustHtml(icon.sourceCode));
    }
  }
}
